import http from '../httpService';

const JudicialDistrictsService = {
  getJudicialDistrictsService: params => http.get(`judicial-districts`, { params }),
};

export default JudicialDistrictsService;
